import { BackgroundType } from './types';

const BASE_CANVAS_WIDTH = 3500; // Базовая ширина холста
const EXTRA_SCROLL_WIDTH = 1000; // Дополнительная ширина для скролла
const MAX_CANVAS_WIDTH = BASE_CANVAS_WIDTH + EXTRA_SCROLL_WIDTH; // Максимальная ширина холста
const GRID_SIZE = 20; // Размер клетки
const MAJOR_GRID_SIZE = GRID_SIZE * 5; // Размер основной сетки
const EXTRA_PADDING = 1; // Небольшой запас для последней клетки

export const drawBackground = (
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  backgroundType: BackgroundType,
  offsetX: number,
  offsetY: number,
  scale: number
) => {
  if (backgroundType === 'black') {
    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, width, height);
  } else {
    drawGrid(ctx, width, height, offsetX, offsetY, scale);
  }
};

const drawGrid = (
  ctx: CanvasRenderingContext2D, 
  width: number, 
  height: number,
  offsetX: number,
  offsetY: number,
  scale: number
) => {
  // Определяем видимую область в виртуальных координатах
  const virtualLeft = offsetX / scale;
  const virtualTop = offsetY / scale;
  const virtualRight = virtualLeft + width / scale;
const virtualBottom = virtualTop + height / scale + 2000;
  
  // Ограничиваем правую границу видимой области
  const clampedVirtualRight = Math.min(virtualRight, MAX_CANVAS_WIDTH);
  
  // Основной фон тетрадного листа
  ctx.fillStyle = '#fff9f9';
  ctx.fillRect(0, 0, width, height);
  
  // Сетка
  ctx.strokeStyle = '#e0e0e0';
  ctx.lineWidth = 0.5;
  
  // Рассчитываем диапазон для вертикальных линий с запасом
  let startVirtualX = Math.floor(virtualLeft / GRID_SIZE) * GRID_SIZE;
  // Убедимся, что начинаем с неотрицательной координаты
  startVirtualX = Math.max(0, startVirtualX);
  
  let endVirtualX = Math.ceil(clampedVirtualRight / GRID_SIZE) * GRID_SIZE + EXTRA_PADDING;
  // Убедимся, что не превышаем максимальную ширину
  endVirtualX = Math.min(endVirtualX, MAX_CANVAS_WIDTH);
  
  // Вертикальные линии
  for (let virtualX = startVirtualX; virtualX <= endVirtualX; virtualX += GRID_SIZE) {
    // Преобразуем виртуальную координату в экранные координаты
    const screenX = virtualX * scale - offsetX;
    
    // Проверяем, что линия находится в пределах видимой области
    if (screenX >= -EXTRA_PADDING && screenX <= width + EXTRA_PADDING) {
      ctx.beginPath();
      ctx.moveTo(screenX, 0);
      ctx.lineTo(screenX, height);
      ctx.stroke();
    }
  }
  
  // Горизонтальные линии
  const startVirtualY = Math.floor(virtualTop / GRID_SIZE) * GRID_SIZE;
  const endVirtualY = Math.ceil(virtualBottom / GRID_SIZE) * GRID_SIZE + EXTRA_PADDING;
  
  for (let virtualY = startVirtualY; virtualY <= endVirtualY; virtualY += GRID_SIZE) {
    const screenY = virtualY * scale - offsetY;
    if (screenY >= -EXTRA_PADDING && screenY <= height + EXTRA_PADDING) {
      ctx.beginPath();
      ctx.moveTo(0, screenY);
      ctx.lineTo(width, screenY);
      ctx.stroke();
    }
  }
  
  // Более толстые линии каждые 5 клеток (основные линии)
  ctx.strokeStyle = '#a0a0a0';
  ctx.lineWidth = 1;
  
  // Вертикальные основные линии
  let startMajorVirtualX = Math.floor(virtualLeft / MAJOR_GRID_SIZE) * MAJOR_GRID_SIZE;
  startMajorVirtualX = Math.max(0, startMajorVirtualX);
  
  let endMajorVirtualX = Math.ceil(clampedVirtualRight / MAJOR_GRID_SIZE) * MAJOR_GRID_SIZE + EXTRA_PADDING;
  endMajorVirtualX = Math.min(endMajorVirtualX, MAX_CANVAS_WIDTH);
  
  for (let majorVirtualX = startMajorVirtualX; majorVirtualX <= endMajorVirtualX; majorVirtualX += MAJOR_GRID_SIZE) {
    const screenX = majorVirtualX * scale - offsetX;
    if (screenX >= -EXTRA_PADDING && screenX <= width + EXTRA_PADDING) {
      ctx.beginPath();
      ctx.moveTo(screenX, 0);
      ctx.lineTo(screenX, height);
      ctx.stroke();
    }
  }
  
  // Горизонтальные основные линии
  const startMajorVirtualY = Math.floor(virtualTop / MAJOR_GRID_SIZE) * MAJOR_GRID_SIZE;
  const endMajorVirtualY = Math.ceil(virtualBottom / MAJOR_GRID_SIZE) * MAJOR_GRID_SIZE + EXTRA_PADDING;
  
  for (let majorVirtualY = startMajorVirtualY; majorVirtualY <= endMajorVirtualY; majorVirtualY += MAJOR_GRID_SIZE) {
    const screenY = majorVirtualY * scale - offsetY;
    if (screenY >= -EXTRA_PADDING && screenY <= height + EXTRA_PADDING) {
      ctx.beginPath();
      ctx.moveTo(0, screenY);
      ctx.lineTo(width, screenY);
      ctx.stroke();
    }
  }
};